import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, Column, Typography } from 'seagull';
export const NativeBootstrapRetryScreen = (param)=>{
    let { onRetry } = param;
    return /*#__PURE__*/ _jsx(Box, {
        padding: 24,
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 16,
            alignItems: "center",
            width: 320,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h3",
                    children: "Unable to connect"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    children: "Check your internet connection and try again."
                }),
                /*#__PURE__*/ _jsx(Button, {
                    onClick: onRetry,
                    bi: {
                        name: 'native_bootstrap_retry'
                    },
                    children: "Retry"
                })
            ]
        })
    });
};
